import { PropsWithChildren } from 'react'

export const TextBlock = (props: PropsWithChildren) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-center mb-10">
      {props.children}
    </div>
  )
}
